export const staffEnvironment = {
  production: true,
  apiUrl: 'https://api.petszel.com/',
  bgNavColor: '#1c7690'
};